import { ScadaPlusError } from "./ScadaPlusError";
export default ScadaPlusError;
